<lyceo-card class="card">
  <div class="text-container">
    <span class="notification-title" data-testid="notification-title">{{
      notificationTitle()
    }}</span>
    @if (notificationText()) {
      <span class="notification-text mt-1" data-testid="notification-text">{{
        notificationText()
      }}</span>
    }
  </div>
  <ng-content />
</lyceo-card>
